import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-pt-0 tw-p-10 tw-flex tw-flex-col" }
const _hoisted_2 = { class: "tw-text-[25px] tw-flex tw-flex-col tw-gap-[10px]" }
const _hoisted_3 = { class: "tw-font-semibold tw-text-[#211F58] tw-leading-[normal] tw-mb-[15px]" }
const _hoisted_4 = { class: "tw-text-[15px] tw-flex tw-flex-col tw-gap-[20px] tw-text-[#231F20]" }
const _hoisted_5 = { class: "tw-font-semibold" }
const _hoisted_6 = { class: "tw-pt-10" }
const _hoisted_7 = { class: "tw-flex tw-justify-end tw-mt-10" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "tw-h-[39px] tw-w-[39px]"
}

import ProgressAnimation from "../../assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";
import ModalHeader from "../../components/common/modalHeader.vue";
import { getComponentUiText } from "../../utils/utilities";
import { ref, watch } from "vue";
import ModalComponent from "../../components/common/modalComponent.vue";
import { INPUT_TYPE } from "@/utils/constants";
import WizardInputQuestion from "./wizardInputQuestion.vue";
import store from "@/store";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'deleteModal',
  props: {
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  endDate: {
    type: String,
    required: true,
  },
  show: {
    type: Boolean,
    required: true,
  },
  idItem: {
    type: Number,
    required: false,
    default: null,
  },
  page: {
    type: String,
    required: true,
  },
},
  emits: [
  "update:show",
  "update:data",
  "delete:data",
  "delete:data:error",
],
  setup(__props, { emit }) {

const props = __props;



let showRef = ref(props.show);
const endDate = ref(props.endDate);
const validDate: any = ref(null);
const loadingDelete = ref(false);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

watch(
  () => endDate.value,
  () => {
    if (endDate.value) {
      validDate.value = null;
    }
  },
);


const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const updateData = () => {
  if (!endDate.value) {
    validDate.value = false;
    return;
  }
  showRef.value = false;
  emit("update:data", endDate.value);
  emit("update:show", showRef.value);
};
const deleteData = async () => {
  if (props.idItem) {
    loadingDelete.value = true;
    try {
      const res = await store.dispatch("SetupWizard/handleDeleteItem", {
        page: props.page,
        id: props.idItem,
      });
      emit("delete:data", { data: res });
      showRef.value = false;
      emit("update:show", showRef.value);
    } catch (error) {
      emit("delete:data:error");
      showErrorAPI(error, Org.postDomainSetup);
    } finally {
      loadingDelete.value = false;
    }
  } else {
    showRef.value = false;
    emit("update:show", showRef.value);
    emit("delete:data", { data: null });
  }
};

const styleClassContain = {
  "border-radius": "4px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
  overflow: "unset",
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(ModalComponent, {
    "model-value": _unref(showRef),
    close: handleCloseModal,
    "max-width": 38,
    "style-class-contain": styleClassContain,
    "class-name": `tw-z-[1071]`
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        "is-header": `no__header`,
        style: {"z-index":"10"},
        title: "",
        onClose: handleCloseModal
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(__props.description) + " ", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
                "app-settings-team-members-profile-modal-delete-action-helper-b-1",
              )), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(WizardInputQuestion, {
            modelValue: endDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((endDate).value = $event)),
            type: _unref(INPUT_TYPE).Date,
            title: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-modal-services-end-date-question-1',
            )
          ,
            required: true,
            placeholder: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-start-date-title',
            )
          ,
            "valid-state": validDate.value,
            "valid-message": 
            _unref(getComponentUiText)('app-setting-org-detail-required-fields-1')
          ,
            "class-title": 'tw-text-[14px] !tw-leading-[100%]',
            "col-class": "col-sm-8"
          }, null, 8, ["modelValue", "type", "title", "placeholder", "valid-state", "valid-message"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_b_button, {
            style: {"line-height":"90%","border":"2px solid #387dff","height":"39px"},
            variant: "primary",
            class: "tw-w-fit tw-mr-[15px] tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
            type: "submit",
            disabled: loadingDelete.value,
            onClick: handleCloseModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
            )), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_b_button, {
            style: {"line-height":"90%","border":"2px solid #387dff","height":"39px"},
            variant: "primary",
            class: "tw-w-fit tw-mr-[15px] tw-shadow-none tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
            type: "submit",
            disabled: loadingDelete.value,
            onClick: updateData
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-wizards-setup-wizard-modal-delete-button-title-update-1",
            )), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createElementVNode("button", {
            class: _normalizeClass(`${
            loadingDelete.value
              ? 'tw-text-[transparent] tw-w-[84px] tw-flex tw-justify-center tw-items-center'
              : 'tw-text-white'
          } tw-bg-[#F7553C] hover:!tw-bg-[#c82333] tw-border-[#F7553C] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-h-[39px] tw-leading-[100%] tw-font-medium`),
            onClick: deleteData
          }, [
            (!loadingDelete.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(getComponentUiText)(
              "app-settings-domain-verify-modal-delete-button-1",
            )), 1))
              : _createCommentVNode("", true),
            (loadingDelete.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_unref(LottieAnimation), {
                    ref: "anim",
                    "animation-data": _unref(ProgressAnimation),
                    "auto-play": true,
                    loop: true
                  }, null, 8, ["animation-data"])
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})